module.exports = __webpack_public_path__ + "static/media/lease5_img2.68d22aec.jpg";